// extracted by mini-css-extract-plugin
module.exports = {"container":"ReactivateAccount_container__2cL5a","details":"ReactivateAccount_details__2WGpk"};